import React from "react";
import Option from "./Option";
import "./ProofOptions.css";

const ProofOptions = ({
  selectedProofOption,
  handleSelectProofOption,
  hasArt,
  showError,
}) => {
  return (
    <ul className={`proof-options ${showError ? 'proof-options--error' : ''}`}>
      {!hasArt && (
        <Option
          optionValue="asis"
          selected={selectedProofOption}
          handleSelectProofOption={handleSelectProofOption}
          showError={showError}
        >
          <h3 className="proof-options__header">
            Print As Is <span className="proof-options__required">*</span>
          </h3>
          <p>
            I confirm that I have reviewed my design and I understand it will be
            produced as shown and no proof will be provided.
          </p>
        </Option>
      )}
      {!hasArt && (
        <Option
          optionValue="digitalproof"
          selected={selectedProofOption}
          handleSelectProofOption={handleSelectProofOption}
          showError={showError}
        >
          <h3 className="proof-options__header">
            Digital Proof + $15 <span className="proof-options__required">*</span>
          </h3>
          <p>
            I would like an expert FYP designer to look at my design, make minor
            corrections if necessary, and send me a black and white proof before
            the order is produced.
          </p>
        </Option>
      )}
      {hasArt && (
        <Option
          optionValue="asis"
          selected={selectedProofOption}
          handleSelectProofOption={handleSelectProofOption}
          showError={showError}
        >
          <h3 className="proof-options__header">
            Print As Is <span className="proof-options__required">*</span>
          </h3>
          <p>
            I confirm that I have reviewed my design and I understand it will be
            produced as shown and no proof will be provided.
          </p>
          <p className="proof-options__pinktext">
            If we determine there is an issue with your artwork, we will e-mail
            you a proof that will require approval.
          </p>
        </Option>
      )}
      {hasArt && (
        <Option
          optionValue="digitalproof"
          selected={selectedProofOption}
          handleSelectProofOption={handleSelectProofOption}
          showError={showError}
        >
          <h3 className="proof-options__header">
            Digital Proof <span className="proof-options__required">*</span>
          </h3>
          <p>
            I would like to receive a black and white PDF proof before the order
            is produced, even if no adjustments are needed for production. I
            understand that it may take up to 2 business days before I receive
            this proof and that my approval will be required before the order
            continues in production.
          </p>
        </Option>
      )}
    </ul>
  );
};

export default ProofOptions;
